import { CommonModule } from '@angular/common';
import { HttpStatusCode } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgbModal, NgbPopover, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';

import { TruncatePipe } from '../../pipes/truncate-text.pipe';

import { AuthService } from '../../service/auth/auth.service';

import { MenuEnum } from '../../model/enum/menu-enum';
import { ApiService } from '../../service/helper/api.service';
import { ScreenService } from '../../service/helper/screen.service';
import { TablerIcon } from '../tabler-icon/tabler-icon-list';
import { TablerIconComponent } from '../tabler-icon/tabler-icon.component';

type MenuItem = any
@Component({
  selector: 'app-sidebar',
  imports: [
    TablerIconComponent,
    CommonModule,
    RouterModule,
    FormsModule,
    // OverflowTooltipDirective,
    TruncatePipe,
    NgbTooltip,
    NgbPopover,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements AfterViewInit, OnDestroy {
  isCollapsed = false;
  isMobileSidebarVisible = false;

  isMobile$!: Observable<boolean>;
  isTablet$!: Observable<boolean>;
  isPc$!: Observable<boolean>;

  _TablerIcon: any = TablerIcon;
  menuItems: MenuItem[] = [
    {
      "sub_menu": null,
      "official_menu_id": 1,
      "name": "Dashboard",
      "ref_official_menu_id": 0,
      "path": "/",
      "icon": "home",
      "is_sub_menu": false,
      "status_use": true,
      "status_summary": true,
      "status_create": false,
      "status_delete": false,
      "status_update": false
    },
    {
      "sub_menu": null,
      "official_menu_id": 2,
      "name": "โปรไฟล์",
      "ref_official_menu_id": 0,
      "path": "/profile",
      "icon": null,
      "is_sub_menu": false,
      "status_use": true,
      "status_summary": false,
      "status_create": false,
      "status_delete": false,
      "status_update": true
    },
    {
      "sub_menu": null,
      "official_menu_id": 3,
      "name": "จัดการคำขออุทธรณ์",
      "ref_official_menu_id": 0,
      "path": "/appeal-manage",
      "icon": "file-check",
      "is_sub_menu": false,
      "status_use": true,
      "status_summary": true,
      "status_create": true,
      "status_delete": true,
      "status_update": true
    }
  ];

  // userDetail: UserCredential | null = null

  noti_count_socket_subsciprtion!: Subscription
  noti_count: number = 0

  _MenuEnum = MenuEnum

  constructor(
    private router: Router,
    private dialog: NgbModal,
    private authService: AuthService,
    private screenService: ScreenService,
    private apiService: ApiService,
    // private notiSocketSrv: NotiSocketService,
    // private chatSocketSrv: ChatSocketService
  ) {
    this.isMobile$ = this.screenService.isMobile$();
    this.isTablet$ = this.screenService.isTablet$();
    this.isPc$ = this.screenService.isPc$();

    this.isMobile$.subscribe((isMobile) => {
      if (isMobile) {
        this.isCollapsed = false;
      } else {
        this.isMobileSidebarVisible = false;
      }
    });

    this.isTablet$.subscribe((isTablet) => {
      if (isTablet) {
        this.isCollapsed = false;
      } else {
        this.isMobileSidebarVisible = false;
      }
    });

    this.authService.menuAndPermission$.subscribe(menu => {
      if (menu) {
        this.menuItems = menu
        console.log('menuList', this.menuItems)
      }
    })

    // this.userDetail = this.authService.getUserCredential()


    this.getNotiCount()
    // this.getMenu()
  }

  getNotiCount() {
    // this.notiSocketSrv.getNotiCount().then((res) => {
    //   this.noti_count = res.count ?? 0
    // })

    // this.noti_count_socket_subsciprtion = this.notiSocketSrv.noti_count_subject$.subscribe(() => {
    //   this.notiSocketSrv.getNotiCount().then((res) => {
    //     this.noti_count = res.count ?? 0
    //   })
    // })
  }

  ngOnDestroy(): void {
    // this.noti_count_socket_subsciprtion.unsubscribe()
  }

  ngAfterViewInit(): void {

  }



  getMenu() {
    this.apiService.get('User/GetMenu').subscribe({
      next: res => {
        if (res.body?.data && res.body.status_code == HttpStatusCode.Ok) {
          this.menuItems = res.body?.data || []
        } else {
          this.authService.logout()

        }
      }, error: err => {
        this.authService.logout()
      }
    })
  }

  submenuState = new Map<any, boolean>();

  toggleSubmenu(item: any) {
    const current = this.submenuState.get(item) ?? true;
    this.submenuState.set(item, !current);
  }

  isSubmenuCollapsed(item: any): boolean {
    return this.submenuState.get(item) ?? true;
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;

    if (this.isCollapsed) {
      this.submenuState.forEach((_, key) => {
        this.submenuState.set(key, true); // true = collapsed
      });
    }
  }

  forceHide(official_menu_id: number | null): boolean {
    if (!official_menu_id) return false

    let id_toHide_list: number[] = []

    let isFound = id_toHide_list.find(official_menu_id_in_list => official_menu_id_in_list === official_menu_id)

    if (isFound) return false

    return true
  }

  toggleMobileSidebar(): void {
    this.isMobileSidebarVisible = !this.isMobileSidebarVisible;
  }

  closeMobileSidebar(): void {
    this.isMobileSidebarVisible = false;
  }

  goProfile() {
    this.router.navigate(['/profile']);
  }

  closeSocket() {
    console.log('force disconnet')
    // this.notiSocketSrv.disconnect()
    // this.chatSocketSrv.disconnectAll()

    // this.notiSocketSrv.simulateHardDisconnect()
  }


  goHomePage() {
    this.router.navigateByUrl('/')
  }
}
